
import Vue from 'vue'
import VueI18n from 'vue-i18n'

import zh from './zh-CN' 
import en from './en-US'
import zang from './zang'

Vue.use(VueI18n)

const messages = {
	'zh-CN' : zh,
	'en-US' : en,
	'zang' : zang
}

const i18n = new VueI18n({
	locale: 'zh-CN',
	messages
})

export default i18n;


// WEBPACK FOOTER //
// ./src/utils/language.js